// @flow
import React from 'react';
import classNames from 'classnames';
import {filter as filterGraphQlAnywhere} from 'graphql-anywhere';
import Rating, {fragments as ratingFragments} from '../Rating/Rating';

import Details from '../Details/Details';
import GeoDistance from '../GeoDistance/GeoDistance';
import RankedBadgesCollection from '../RankedBadgesCollection/RankedBadgesCollection';
import UrgencyMessage from '../UrgencyMessage/UrgencyMessage';
import BadgeTooltip from './ReviewBadgeTooltip';
import {DualPrice} from '../DualPrice/DualPrice';
import {FREE_CANCELLATION} from '../../constants/badges';
import WebRatingBadge from '../WebRatingBadge/WebRatingBadge';
import {hasBadges} from './HitInfoDesktop';

import type {Props as HitInfoProps} from './HitInfo';

type Props = HitInfoProps;

const Superlative = ({superlativesBadges, hasReviews}) => {
    const {name, helpText} = superlativesBadges[0];
    const className = classNames('HitInfo__superlative', {
        'HitInfo__superlative--has-reviews': hasReviews
    });

    return (
        <span>
            <span className={className}>{name}</span>
            {helpText && <BadgeTooltip helpText={helpText} />}
        </span>
    );
};

// TODO: move minStay logic to lingua
// https://jira.homeawaycorp.com/browse/SERP-2848
export default function HitInfoMobile({brand, intl, isMetric, listing}: Props) {
    const {reviewCount, geoDistance, unitMessage} = listing;

    const rankedBadges = listing.rankedBadges || [];
    const superlativesBadges = listing.superlativesBadges || [];
    const webRatingBadges = listing.webRatingBadges || [];
    const hasSuperlativeBadges = hasBadges(superlativesBadges);
    const showWebRatingBadge = reviewCount === 0 && hasBadges(webRatingBadges);

    let freeCancellationBadge = rankedBadges.find(
        (e) => e.id === FREE_CANCELLATION
    );

    const BadgeRatingGroup = () => {
        return (
            <div className="HitInfo__badgeRatingGroup">
                {reviewCount > 0 && (
                    <div className="HitInfo__rating">
                        <Rating
                            listing={filterGraphQlAnywhere(
                                ratingFragments.Listing,
                                listing
                            )}
                            isDualPrice
                        />
                    </div>
                )}
            </div>
        );
    };

    const DualPriceWrapper = () => {
        return (
            <div>
                <div className="media-flex__row">
                    <BadgeRatingGroup isDualPrice />
                    {hasSuperlativeBadges && (
                        <Superlative
                            superlativesBadges={superlativesBadges}
                            hasReviews={reviewCount > 0}
                        />
                    )}
                </div>
                {showWebRatingBadge && (
                    <div className="media-flex__row">
                        <WebRatingBadge badge={webRatingBadges[0]} />
                    </div>
                )}
                <div className="HitInfo__details">
                    <Details
                        listing={listing}
                        isMetric={isMetric}
                        locale={intl.locale}
                    />
                </div>
                {geoDistance && (
                    <GeoDistance geoDistance={geoDistance} brand={brand} />
                )}
                <RankedBadgesCollection
                    rankedBadges={rankedBadges}
                    isDualPrice
                />
                <div className="HitInfo__priceSuperlativeGroup">
                    <DualPrice
                        listing={listing}
                        intl={intl}
                        isDesktop={false}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="media-flex__left">
            <UrgencyMessage
                unitMessage={unitMessage}
                freeCancellationBadge={freeCancellationBadge}
            />
            <DualPriceWrapper />
        </div>
    );
}
